import { Navigate, Route, useParams } from 'react-router-dom';
import { FinancialAidLayout } from '../components/FinancialAidLayout';
import {
  Dashboard as FinancialAidStaffDashboardPage,
} from '../../internal-owned/school-financial-aid-v2-1/pages/Dashboard';
import {
  ApplicantDetail as FinancialAidStaffApplicantDetailPage,
} from '../../internal-owned/school-financial-aid-v2-1/pages/ApplicantDetail';
import { FamilyTab as FinancialAidFamilyProfileTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/FamilyTab';
import { IncomeTab as FinancialAidIncomeCalculationTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/IncomeTab';
import { AssetsTab as FinancialAidAssetsEquityTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/AssetsTab';
import { ExpensesTab as FinancialAidExpensesSpendingTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/ExpensesTab';
import { ContractTab as FinancialAidContractFlagsTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/ContractTab';
import { CorrectionsTab as FinancialAidCorrectionsTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/CorrectionsTab';
import { DocumentsTab as FinancialAidDocumentsTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/DocumentsTab';
import { NotesTab as FinancialAidNotesTab } from '../../internal-owned/school-financial-aid-v2-1/pages/tabs/NotesTab';
import { HelpPage as FinancialAidHelpPage } from './HelpPage';

const FinancialAidApplicationAliasRoute = () => {
  const { applicationId, tab } = useParams<{ applicationId: string; tab?: string }>();
  if (!applicationId) {
    return <Navigate to="/school/financialaid/staff" replace />;
  }
  const suffix = tab ? `/${tab}` : '/family-profile';
  return <Navigate to={`/school/financialaid/staff/${applicationId}${suffix}`} replace />;
};

export const FinancialAidRoutes = (
  <Route element={<FinancialAidLayout />}>
    <Route index element={<Navigate to="staff" replace />} />
    {/* Staff-only school financial-aid routes. Parent flows live under /parent/portal/* */}
    <Route path="staff" element={<FinancialAidStaffDashboardPage />} />
    <Route path="staff/reports" element={<Navigate to="/school/financialaid/staff" replace />} />
    <Route path="staff/appeals" element={<Navigate to="/school/financialaid/staff" replace />} />
    <Route path="staff/:applicationId" element={<FinancialAidStaffApplicantDetailPage />}>
      <Route index element={<Navigate to="family-profile" replace />} />
      <Route path="family-profile" element={<FinancialAidFamilyProfileTab />} />
      <Route path="income-calculation" element={<FinancialAidIncomeCalculationTab />} />
      <Route path="assets-equity" element={<FinancialAidAssetsEquityTab />} />
      <Route path="expenses-spending" element={<FinancialAidExpensesSpendingTab />} />
      <Route path="contract-flags" element={<FinancialAidContractFlagsTab />} />
      <Route path="corrections" element={<FinancialAidCorrectionsTab />} />
      <Route path="documents" element={<FinancialAidDocumentsTab />} />
      <Route path="notes" element={<FinancialAidNotesTab />} />
      <Route path="*" element={<Navigate to="family-profile" replace />} />
    </Route>
    <Route path="application/:applicationId" element={<FinancialAidApplicationAliasRoute />} />
    <Route path="application/:applicationId/:tab" element={<FinancialAidApplicationAliasRoute />} />
    <Route path="apply" element={<Navigate to="staff" replace />} />
    <Route path="documents" element={<Navigate to="staff" replace />} />
    <Route path="status" element={<Navigate to="staff" replace />} />
    <Route path="appeal" element={<Navigate to="staff" replace />} />
    <Route path="help" element={<FinancialAidHelpPage />} />
    <Route path="*" element={<Navigate to="staff" replace />} />
  </Route>
);
